module.exports = __webpack_public_path__ + "img/helicopter.be5030ca.webp";